import type { AddressSearchQuery, AddressSearchResponse, AddressSearchResult, CustomerDto, CustomerResponse } from "@/types";
import { defineStore } from "pinia";
import { ref } from "vue";
import local from "./local";
import axios from "axios";

export const useCustomerStore = defineStore('customer', () => {
  const savedCustomer = ref<CustomerDto>()

  async function getCustomer(email: string): Promise<CustomerResponse | undefined> {
    const data = await axios.get<any, CustomerResponse[]>(`proxy/customers?email=${email}`)

    return data?.length ? data[0] : undefined
  }

  async function createCustomer(customer: CustomerDto) {
    customer.status = "1" // Must be one to be active

    const { id } = await axios.post<CustomerDto, CustomerResponse>('proxy/customers', customer)

    return id
  }

  async function searchAddresses(query: AddressSearchQuery): Promise<AddressSearchResult[]> {
    try {
      const { data } = await axios.get<AddressSearchResponse>('proxy/addresses', { params: query })

      return data.fund
    } catch (error) {
      // The API answers 404 when nothing matches, e.g. a misspelled address
      if (axios.isAxiosError(error) && error.response?.status === 404) {
        return []
      }

      throw error
    }
  }

  local.getItem('customerForm').then(res => {
    if (res) {
      savedCustomer.value = res as CustomerDto
    }
  })

  function reset() {
    savedCustomer.value = undefined
  }

  return {
    savedCustomer,
    getCustomer,
    createCustomer,
    searchAddresses,
    reset
  }
})